import { useMemo, useState } from 'react'
import { User01Icon } from '@/components/ui/icons'
import { QueueFilterSelect } from '@/features/luxe-submissions/components/queue-filter-select'
import { useGetReviewers } from '@/features/luxe-submissions/queries/use-get-reviewers'
import type { LuxeReviewerSection } from '@/features/luxe-submissions/types'
import { getReviewerName } from '../utils'

interface FilterVetterSelectProps {
	section: LuxeReviewerSection
	onChange: (vetterId: string | null) => void
	userId?: string
	selectedId: string | null
	placeholder?: string
}

function FilterVetterSelect({
	section,
	userId,
	selectedId,
	onChange,
	placeholder = 'Vetter'
}: FilterVetterSelectProps) {
	const [reviewerSearch, setReviewerSearch] = useState('')

	const {
		remappedData: reviewers,
		isLoading: isLoadingReviewers,
		isFetchingNextPage: isFetchingNextReviewers,
		hasNextPage: hasNextReviewers,
		fetchNextPage: fetchNextReviewers
	} = useGetReviewers(section, reviewerSearch)

	// Reviewers for filter with "(You)" for current user
	const reviewersForFilter = useMemo(() => {
		return reviewers.map((reviewer) => {
			const { fullName } = getReviewerName({
				...reviewer,
				isMe: reviewer.id.toString() === userId
			})
			return {
				...reviewer,
				displayName: fullName
			}
		})
	}, [reviewers, userId])

	return (
		<QueueFilterSelect
			fetchNextPage={fetchNextReviewers}
			getItemId={(item) => item.id.toString()}
			getItemLabel={(item) => item.displayName}
			hasNextPage={hasNextReviewers}
			icon={<User01Icon size={20} />}
			isFetchingNextPage={isFetchingNextReviewers}
			isLoading={isLoadingReviewers}
			items={reviewersForFilter}
			onChange={onChange}
			onSearch={setReviewerSearch}
			placeholder={placeholder}
			value={selectedId}
		/>
	)
}
export { FilterVetterSelect }
